export default __webpack_public_path__ + "static/media/cart.2c9614c5.jpg";